/** Event Management sidebar menu keys. */
export const EVENT_MANAGEMENT_MENU_KEY = "event-management";
export const EVENT_CREATION_MENU_KEY = "event-creation";
export const EVENTS_REQUEST_MENU_KEY = "events-request";
export const EVENTS_CLONE_MENU_KEY = "events-clone";
